// import React, { useState, useEffect } from "react";
// import { Row, Col, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
// import { getClassOwnerChangeReasons } from "../services/APIClient"; // Import the function
// import "./EditClassDetails.css";

// function EditClassTeacherSpecialDetails({
//   currentTeacherName,
//   classOwnerName,
//   teachers,
//   setNewClassTeacherId,
//   setClassOwnerChangeReason,
// }) {
//   const [showChangeReasonDropdown, setShowChangeReasonDropdown] =
//     useState(false);
//   const [changeReasons, setChangeReasons] = useState([]);
//   const [selectedReason, setSelectedReason] = useState({ id: "", reason: "" });

//   // Fetch the class ownership change reasons
//   useEffect(() => {
//     const fetchChangeReasons = async () => {
//       try {
//         const reasons = await getClassOwnerChangeReasons();
//         setChangeReasons(reasons);
//       } catch (error) {
//         console.error("Error fetching class ownership change reasons:", error);
//       }
//     };

//     fetchChangeReasons();
//   }, []);

//   // Handle dropdown change for new teacher
//   const handleTeacherChange = (e) => {
//     const selectedTeacherId = e.target.value;
//     setNewClassTeacherId(selectedTeacherId);

//     // Show or hide the change reason dropdown based on selection
//     if (selectedTeacherId) {
//       setShowChangeReasonDropdown(true);
//     } else {
//       setShowChangeReasonDropdown(false);
//       setSelectedReason({ id: "", reason: "" }); // Reset reason when no teacher is selected
//     }
//   };

//   // Handle change reason selection
//   const handleReasonChange = (event) => {
//     const selectedValue = event.target.value;
//     const reason = changeReasons.find((reason) => reason.id === selectedValue); // Find the reason object
//     setSelectedReason(reason || { id: "", reason: "" }); // Save both the ID and reason text
//     setClassOwnerChangeReason(reason ? reason.reason : ""); // Pass the reason text back to the parent
//   };

//   // Tooltip content
//   const tooltip = (
//     <Tooltip id="teacher-tooltip">
//       If the new teacher isn't listed, please go to the "Invite Colleagues"
//       section on the homepage and invite them before creating their class! If
//       you have already invited them, please ensure they have created their
//       account first before creating their classroom!
//     </Tooltip>
//   );

//   // Determine the old class teacher to display
//   const oldClassTeacherName = classOwnerName || currentTeacherName;

//   return (
//     <Form className="form">
//       {/* Old Class Teacher Field */}
//       {/* <Form.Group as={Row} className="mb-3" controlId="old-class-teacher">
//         <Form.Label className="label" column sm="4">
//           <p>Old Class Teacher</p>
//         </Form.Label>
//         <Col sm="8">
//           <Form.Control
//             placeholder={oldClassTeacherName}
//             size="md"
//             type="text"
//             disabled
//           />
//         </Col>
//       </Form.Group> */}

//       {/* New Class Teacher Field */}
//       <Form.Group as={Row} className="mb-3" controlId="new-class-teacher">
//         <Form.Label className="label" column sm="4">
//           <p>New Class Teacher</p>
//         </Form.Label>
//         <Col sm="7">
//           <Form.Control
//             className="teacher-dropdown"
//             as="select"
//             size="md"
//             onChange={handleTeacherChange}
//           >
//             <option value="">Select a Teacher</option>
//             {teachers.map((teacher) => (
//               <option key={teacher.id} value={teacher.id}>
//                 {teacher.name}
//               </option>
//             ))}
//           </Form.Control>
//         </Col>
//         <Col sm="1">
//           {/* Tooltip Icon */}
//           {/* <OverlayTrigger placement="right" overlay={tooltip}>
//             <FontAwesomeIcon
//               icon={faInfoCircle}
//               className="fa-2x"
//               style={{ cursor: "pointer", color: "red" }}
//             />
//           </OverlayTrigger> */}
//         </Col>
//       </Form.Group>

//       {/* Conditionally display dropdown for class ownership change reason */}
//       {showChangeReasonDropdown && (
//         <Form.Group
//           as={Row}
//           className="mb-3"
//           controlId="class-owner-change-reason"
//         >
//           <Form.Label className="label" column sm="4">
//             <p>Reason for Change</p>
//           </Form.Label>
//           <Col sm="8">
//             <Form.Control
//               as="select"
//               value={selectedReason.id || ""} // Set to empty string if id is undefined
//               onChange={handleReasonChange}
//               className="teacher-dropdown"
//             >
//               <option value="">Select a reason</option>
//               {changeReasons.map((reason) => (
//                 <option key={reason.id} value={reason.id}>
//                   {reason.reason}
//                 </option>
//               ))}
//             </Form.Control>
//           </Col>
//         </Form.Group>
//       )}
//     </Form>
//   );
// }

// export default EditClassTeacherSpecialDetails;

import React, { useState, useEffect } from "react";
import { Row, Col, Form, Alert, Button, Spinner } from "react-bootstrap";
import {
  getTeachersBySchoolIdCheck,
  getPendingTeacherBySchoolId,
  resendTeacherInvite
} from "../services/APIClient";
import "./EditClassDetails.css";

function EditClassTeacherSpecialDetails({
  currentTeacherName,
  classOwnerName,
  teachers,
  setNewClassTeacherId,
  setClassOwnerChangeReason,
  schoolId,
  rollnumber,
  invitingTeacherName,
  countryId,
  classId,
}) {
  const [selectedTeacherId, setSelectedTeacherId] = useState("");
  const [isAddingNewTeacher, setIsAddingNewTeacher] = useState(false);
  const [newTeacherName, setNewTeacherName] = useState("");
  const [newTeacherEmail, setNewTeacherEmail] = useState("");
  const [emailValidation, setEmailValidation] = useState({ isValid: true, message: "" });

  // New state for comprehensive teacher checking
  const [allActiveTeachers, setAllActiveTeachers] = useState([]);
  const [allPendingTeachers, setAllPendingTeachers] = useState([]);
  const [isLoadingTeachers, setIsLoadingTeachers] = useState(true);
  const [teacherCheckResult, setTeacherCheckResult] = useState(null);
  const [isResendingInvite, setIsResendingInvite] = useState(false);

  // Fetch all teachers data when component mounts
  useEffect(() => {
    const fetchAllTeachersData = async () => {
      setIsLoadingTeachers(true);
      try {
        const [activeTeachersResponse, pendingTeachersResponse] = await Promise.all([
          getTeachersBySchoolIdCheck(schoolId),
          getPendingTeacherBySchoolId(schoolId)
        ]);

        setAllActiveTeachers(activeTeachersResponse.data || activeTeachersResponse || []);
        setAllPendingTeachers(pendingTeachersResponse.data || pendingTeachersResponse || []);

        console.log("Active teachers:", activeTeachersResponse);
        console.log("Pending teachers:", pendingTeachersResponse);
        console.log("Pending teachers structure:", pendingTeachersResponse.data || pendingTeachersResponse);
      } catch (error) {
        console.error("Error fetching teachers data:", error);
        // Fallback to using the passed teachers prop
        setAllActiveTeachers(teachers || []);
        setAllPendingTeachers([]);
      } finally {
        setIsLoadingTeachers(false);
      }
    };

    if (schoolId) {
      fetchAllTeachersData();
    }
  }, [schoolId, teachers]);

  // Automatically set the hardcoded reason when component mounts or teacher changes
  useEffect(() => {
    if (selectedTeacherId || isAddingNewTeacher) {
      setClassOwnerChangeReason("Juniors moved to Seniors");
    }
  }, [selectedTeacherId, isAddingNewTeacher, setClassOwnerChangeReason]);

  // Helper function to get teacher name from pending teacher object
  const getPendingTeacherName = (pendingTeacher) => {
    console.log("Extracting name from pending teacher:", pendingTeacher);

    // Use .name field as provided by API
    if (pendingTeacher.name) {
      return pendingTeacher.name;
    }

    // Fallback to email if no name field found
    return pendingTeacher.email || "Unknown Teacher";
  };

  // Comprehensive teacher checking function
  const checkTeacherExists = (email) => {
    if (!email.trim()) {
      return { exists: false, type: null, teacher: null };
    }

    const emailLower = email.toLowerCase();

    // Check active teachers first
    const activeTeacher = allActiveTeachers.find(teacher =>
      teacher.email && teacher.email.toLowerCase() === emailLower
    );

    if (activeTeacher) {
      return {
        exists: true,
        type: 'active',
        teacher: activeTeacher
      };
    }

    // Check pending teachers
    const pendingTeacher = allPendingTeachers.find(teacher =>
      teacher.email && teacher.email.toLowerCase() === emailLower
    );

    if (pendingTeacher) {
      return {
        exists: true,
        type: 'pending',
        teacher: pendingTeacher
      };
    }

    return { exists: false, type: null, teacher: null };
  };

  // Validate email format
  const validateEmail = (email) => {
    if (!email.trim()) {
      return { isValid: true, message: "" };
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      return { isValid: false, message: "Please enter a valid email address" };
    }

    return { isValid: true, message: "" };
  };

  // Handle resending teacher invitation
  const handleResendInvite = async (pendingTeacherId) => {
    setIsResendingInvite(true);
    try {
      await resendTeacherInvite(pendingTeacherId);
      setTeacherCheckResult(prev => ({
        ...prev,
        resendSuccess: true,
        resendMessage: "Invitation resent successfully!"
      }));
    } catch (error) {
      console.error("Error resending invitation:", error);
      setTeacherCheckResult(prev => ({
        ...prev,
        resendSuccess: false,
        resendMessage: "Failed to resend invitation. Please try again."
      }));
    } finally {
      setIsResendingInvite(false);
    }
  };

  // Handle switching to existing active teacher
  const handleSelectActiveTeacher = (teacher) => {
    setIsAddingNewTeacher(false);
    setSelectedTeacherId(teacher.id);
    setNewClassTeacherId(teacher.id);
    setNewTeacherName("");
    setNewTeacherEmail("");
    setTeacherCheckResult(null);
    setEmailValidation({ isValid: true, message: "" });
  };

  // Handle checkbox change for adding new teacher
  const handleCheckboxChange = (e) => {
    const isChecked = e.target.checked;
    setIsAddingNewTeacher(isChecked);

    // Reset state when switching modes
    setTeacherCheckResult(null);
    setEmailValidation({ isValid: true, message: "" });

    if (isChecked) {
      // Switch to new teacher mode
      setSelectedTeacherId("");
      setNewClassTeacherId({
        type: "new_teacher",
        name: newTeacherName,
        email: newTeacherEmail,
        isValid: validateEmail(newTeacherEmail).isValid && newTeacherName.trim() !== ""
      });
    } else {
      // Switch back to existing teacher mode
      setNewTeacherName("");
      setNewTeacherEmail("");
      setNewClassTeacherId("");
    }
  };

  // Handle dropdown change for existing teacher
  const handleTeacherChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedTeacherId(selectedValue);
    setNewClassTeacherId(selectedValue);
  };

  // Handle new teacher name change
  const handleNewTeacherNameChange = (e) => {
    const name = e.target.value;
    setNewTeacherName(name);

    // Update parent with new teacher data
    const emailVal = validateEmail(newTeacherEmail);
    const checkResult = checkTeacherExists(newTeacherEmail);

    setNewClassTeacherId({
      type: "new_teacher",
      name: name,
      email: newTeacherEmail,
      isValid: emailVal.isValid && name.trim() !== "" && !checkResult.exists
    });
  };

  // Handle new teacher email change
  const handleNewTeacherEmailChange = (e) => {
    const email = e.target.value;
    setNewTeacherEmail(email);

    // Validate email format
    const validation = validateEmail(email);
    setEmailValidation(validation);

    // Check for existing teacher (active or pending)
    const checkResult = checkTeacherExists(email);
    setTeacherCheckResult(checkResult);

    // Update parent with new teacher data
    if (checkResult.exists && checkResult.type === 'active') {
      // If active teacher found, automatically use their ID for assignment
      setNewClassTeacherId(checkResult.teacher.id);
    } else {
      // Otherwise, use new teacher format
      setNewClassTeacherId({
        type: "new_teacher",
        name: newTeacherName,
        email: email,
        isValid: validation.isValid && newTeacherName.trim() !== "" && !checkResult.exists
      });
    }
  };

  return (
    <Form className="form">
      {/* Show loading state while fetching teacher data */}
      {isLoadingTeachers && (
        <Row className="mb-3">
          <Col sm={{ span: 8, offset: 4 }}>
            <div className="d-flex align-items-center">
              <Spinner animation="border" size="sm" className="me-2" />
              <span>Loading teacher data...</span>
            </div>
          </Col>
        </Row>
      )}

      {/* Conditional rendering based on checkbox state */}
      {!isAddingNewTeacher ? (
        /* Existing Teacher Selection */
        <Form.Group as={Row} className="mb-3" controlId="existing-class-teacher">
          <Form.Label className="label" column sm="4">
            <p>Select Teacher</p>
          </Form.Label>
          <Col sm="8">
            <Form.Control
              className="teacher-dropdown"
              as="select"
              size="md"
              value={selectedTeacherId}
              onChange={handleTeacherChange}
              disabled={isLoadingTeachers}
            >
              <option value="">Select a Teacher</option>
              {teachers.map((teacher) => (
                <option key={teacher.id} value={teacher.id}>
                  {teacher.name}
                </option>
              ))}
            </Form.Control>
          </Col>
        </Form.Group>
      ) : (
        /* New Teacher Form Fields */
        <>
          {/* New Teacher Name Field */}
          <Form.Group as={Row} className="mb-3" controlId="new-teacher-name">
            <Form.Label className="label" column sm="4">
              <p>Teacher Name <span style={{ color: 'red' }}>*</span></p>
            </Form.Label>
            <Col sm="8">
              <Form.Control
                type="text"
                size="md"
                placeholder="Enter teacher's full name"
                value={newTeacherName}
                onChange={handleNewTeacherNameChange}
                required
                disabled={isLoadingTeachers}
              />
            </Col>
          </Form.Group>

          {/* New Teacher Email Field */}
          <Form.Group as={Row} className="mb-3" controlId="new-teacher-email">
            <Form.Label className="label" column sm="4">
              <p>Teacher Email <span style={{ color: 'red' }}>*</span></p>
            </Form.Label>
            <Col sm="8">
              <Form.Control
                type="email"
                size="md"
                placeholder="Enter teacher's email address"
                value={newTeacherEmail}
                onChange={handleNewTeacherEmailChange}
                required
                disabled={isLoadingTeachers}
                isInvalid={!emailValidation.isValid || (teacherCheckResult && teacherCheckResult.exists)}
              />
              {!emailValidation.isValid && (
                <Form.Control.Feedback type="invalid">
                  {emailValidation.message}
                </Form.Control.Feedback>
              )}
            </Col>
          </Form.Group>

          {/* Teacher Check Results */}
          {teacherCheckResult && teacherCheckResult.exists && (
            <Row className="mb-3">
              <Col sm={{ span: 8, offset: 4 }}>
                {teacherCheckResult.type === 'active' ? (
                  /* Active Teacher Found */
                  <Alert variant="success" className="mb-0">
                    <div>
                      <strong>✅ Perfect! Teacher Found</strong>
                      <br />
                      <span className="text-muted">
                        <strong>{teacherCheckResult.teacher.name}</strong> already has an account with this email.
                      </span>
                      <div className="mt-2 p-2" style={{ backgroundColor: '#d4edda', borderRadius: '0.25rem', border: '1px solid #c3e6cb' }}>
                        <small><strong>🎯 Smart Assignment:</strong> When you click "Save", the class will automatically be assigned to {teacherCheckResult.teacher.name}. No invitation needed!</small>
                      </div>
                      <div className="mt-3">
                        <Button
                          variant="outline-success"
                          size="sm"
                          onClick={() => handleSelectActiveTeacher(teacherCheckResult.teacher)}
                          className="fw-bold"
                        >
                          Or select {teacherCheckResult.teacher.name} from dropdown instead
                        </Button>
                      </div>
                    </div>
                  </Alert>
                ) : (
                  /* Pending Teacher Found */
                  <Alert variant="warning" className="mb-0">
                    <div className="text-center">
                      <strong style={{ fontSize: '1.1rem' }}>⏳ {getPendingTeacherName(teacherCheckResult.teacher)} - Pending Invitation Found!</strong>
                      <br />
                      <span className="text-muted mt-1 d-block">
                        This teacher was already invited but hasn't completed account setup.
                      </span>
                      <div className="mt-3 mb-2">
                        <Button
                          variant="warning"
                          size="lg"
                          onClick={() => handleResendInvite(teacherCheckResult.teacher.id)}
                          disabled={isResendingInvite}
                          className="fw-bold px-4 py-2"
                          style={{
                            fontSize: '1.1rem',
                            boxShadow: '0 4px 8px rgba(255, 193, 7, 0.3)',
                            border: '2px solid #ffc107'
                          }}
                        >
                          {isResendingInvite ? (
                            <>
                              <Spinner animation="border" size="sm" className="me-2" />
                              Resending Invitation...
                            </>
                          ) : (
                            <>
                              📧 Resend Invitation to {getPendingTeacherName(teacherCheckResult.teacher).split(' ')[0]}
                            </>
                          )}
                        </Button>
                      </div>
                      {teacherCheckResult.resendSuccess !== undefined && (
                        <div className={`mt-2 ${teacherCheckResult.resendSuccess ? 'text-success' : 'text-danger'}`} style={{ fontSize: '0.95rem', fontWeight: '500' }}>
                          {teacherCheckResult.resendMessage}
                        </div>
                      )}
                    </div>
                  </Alert>
                )}
              </Col>
            </Row>
          )}

          {/* Success state for new teacher - only show when no conflicts */}
          {!teacherCheckResult?.exists && newTeacherName.trim() && newTeacherEmail.trim() && emailValidation.isValid && !isLoadingTeachers && (
            <Row className="mb-3">
              <Col sm={{ span: 8, offset: 4 }}>
                <div
                  style={{
                    backgroundColor: '#e8f5e8',
                    border: '1px solid #28a745',
                    borderRadius: '0.25rem',
                    padding: '0.75rem',
                    fontSize: '0.875rem',
                    color: '#155724'
                  }}
                >
                  <strong>✓ Ready to Invite:</strong> {newTeacherName} will receive an invitation when you click Save.
                </div>
              </Col>
            </Row>
          )}

          {/* Validation info for incomplete form */}
          {(!newTeacherName.trim() || !newTeacherEmail.trim()) && !isLoadingTeachers && (
            <Row className="mb-3">
              <Col sm={{ span: 8, offset: 4 }}>
                <div
                  style={{
                    backgroundColor: '#fff3cd',
                    border: '1px solid #ffc107',
                    borderRadius: '0.25rem',
                    padding: '0.75rem',
                    fontSize: '0.875rem',
                    color: '#856404'
                  }}
                >
                  <strong>📝 New Teacher Mode:</strong> Please complete both name and email fields. The invitation will be sent when you save the changes.
                </div>
              </Col>
            </Row>
          )}
        </>
      )}
        {/* Checkbox for adding new teacher */}
          <Form.Group as={Row} className="mb-3" controlId="add-new-teacher-checkbox">
            <Col sm={{ span: 8, offset: 4 }}>
              <Form.Check
                type="checkbox"
                id="add-new-teacher"
                label="Assign to teacher not yet in school"
                checked={isAddingNewTeacher}
                onChange={handleCheckboxChange}
                disabled={isLoadingTeachers}
                style={{
                  fontSize: '1rem',
                  fontWeight: '500',
                  color: '#495057'
                }}
              />
            </Col>
          </Form.Group>
    </Form>
  );
}

export default EditClassTeacherSpecialDetails;